module.exports = __webpack_public_path__ + "img/upload-resume.31821fd8.svg";